import axios from "axios"; //导入

let BaseUrl = "https://admin.boaordmc.com";
// let BaseUrl = 'http://boao.huidn.com'
// let BaseUrl = 'https://admin.boaordmc.com'
const _axios = axios.create({
  baseURL: BaseUrl,
});

// 请求拦截
_axios.interceptors.request.use(
  (config) => {
    // config.headers["token"] = localStorage.getItem("token");
    return config;
  },
  (err) => {
    return Promise.reject(err);
  }
);

// 相应拦截
_axios.interceptors.response.use(
  (res) => {
    if (res.data.msg == "导航栏不存在") {
      location.href = "/";
    }
    return res;
  },
  (err) => {
    return Promise.reject(err);
  }
);

export default _axios;
